import { SegmentedControl } from "@mantine/core";
import React, { useRef, useState } from "react";
import { IoMdChatboxes } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { TabContent, TabPane } from "reactstrap";
import { useDebounce } from "use-debounce";
import { setNewChatRole } from "../../Redux/reducers/chatRoleSlice";
import { onChatPressed, toogleChat } from "../../Redux/reducers/chatSlice";
import { setNewConversationID } from "../../Redux/reducers/conversationIdSlice";
import SidebarUser from "./singleItems/SidebarUser";
import { updateCurrentUserData } from "../../Redux/reducers/messagesSlice";

const TabItem = ({ messageCount, label, isActive }) => {
  return <div className="position-relative">
    <p className="mb-0 fw-semibold" style={{ fontSize: 14 }}>{label}</p>
    {messageCount > 0 ? (
      <div
        className="d-flex justify-content-center align-items-center position-absolute"
        style={{
          top: "50%",
          right: "-3%",
          borderRadius: "50%",
          translate: "0% -50%",
          background: isActive ? 'white' : '#d1027e',
          color: isActive ? '#d1027e' : 'white',
          height: 20,
          width: 20
        }}
      >
        <h6
          className="mb-0"
          style={{
            fontSize: "12px",
          }}
        >
          {" "}
          {messageCount}
        </h6>
      </div>
    ) : null}
  </div>
}

const MessageSideBar = ({
  sellers = [],
  customers = [],
  onSellerTabPressed,
  onCustomerTabPressed,
  activeTab,
  setActiveTab,
  customersUnreadCount,
  sellersUnreadCount
}) => {

  const [input, setInput] = useState("");
  const [debouncedText] = useDebounce(input, 1000);
  const dispatch = useDispatch();
  const currRole = useSelector((state) => state.chatRole.role);
  const inputRef = useRef(null);

  const getFilteredSellers = () => {
    return sellers.filter((user) => {
      const isCustomer = currRole === "customer";
      const userName = isCustomer ? user.seller.name : user.customer.name;
      return userName.toLowerCase().includes(debouncedText.toLowerCase());
    });
  };

  const getFilteredCustomer = () => {
    return customers.filter((user) => {
      const isCustomer = currRole === "customer";
      const userName = isCustomer ? user.seller.name : user.customer.name;
      return userName.toLowerCase().includes(debouncedText.toLowerCase());
    });
  };

  // for responsive design in mobile devices.............
  const showSidebar = useSelector(
    (state) => state.responsiveHandle.showSideBar
  );

  const sidebarClass = showSidebar ? "showElement" : "hideElement";

  return (
    <div className={` ${sidebarClass} sidebar`}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",

          justifyContent: "space-between",
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <div
            onClick={() => {
              dispatch(toogleChat());
            }}
            style={{ height: "2rem", width: "2rem", fontSize: 28, borderRadius: 7 }}
            className="cursor-pointer bg-white border d-flex justify-content-center align-items-center"
          >
            &#215;
          </div>
          <h3 className="mb-0">Chats</h3>
        </div>
        <div>
          <IoMdChatboxes
            color="#ec008c"
            size={25}
            style={{ marginBottom: "5px", marginRight: "10px" }}
          />
        </div>
      </div>
      <form

        onSubmit={(e) => {
          e.preventDefault()
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            inputRef.current.blur();
          }
        }}
      >
        <div className="d-flex">
          <input
            placeholder="Search Thrifters . . ."
            className="search-input"
            value={input}
            onChange={(e) => {
              setInput(e.target.value)
            }}
            ref={inputRef}
            style={{
              background: 'transparent',
              border: '1px solid #ededed'
            }}
          />
        </div>
      </form>
      <div style={{ height: 'auto' }}>
        <SegmentedControl
          fullWidth
          value={activeTab}
          onChange={(val) => {
            setActiveTab(val)
            if (val === '1') {
              dispatch(setNewChatRole("customer"));
              onSellerTabPressed();
            } else {
              dispatch(setNewChatRole("seller"));
              onCustomerTabPressed();
            }
          }}
          color="bright-pink"
          data={[
            { value: '1', label: <TabItem isActive={activeTab === '1'} label={'Sellers'} messageCount={sellersUnreadCount} /> },
            { value: '2', label: <TabItem isActive={activeTab === '2'} label={'Customers'} messageCount={customersUnreadCount} /> },
          ]}
        />
      </div>
      <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
        <div className="no-scrollbar tab-content">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              {sellers.length === 0 ? (
                <p>No sellers</p>
              ) : (
                (debouncedText === ""
                  ? sellers
                  : [...getFilteredSellers()]
                ).map((user, key) => {
                  const isCustomer = currRole === "customer";
                  return (
                    <SidebarUser
                      key={key}
                      userId={isCustomer ? user.seller.id : user.customer.id}
                      userName={
                        isCustomer ? user.seller.name : user.customer.name
                      }
                      id={isCustomer ? user.customer.id : user.seller.id}
                      lastMessage={user.message}
                      isMe={user?.position === "left" ? true : false}
                      showBold={user?.show_bold}
                      time={user.created_at}
                      userAvatar={
                        isCustomer ? user.seller.avatar : user.customer.avatar
                      }
                      onPressed={() => {
                        dispatch(setNewConversationID({ id: isCustomer ? user.seller.id : user.customer.id, convContext: 'sellers' }));
                        dispatch(onChatPressed({ chatId: user.id, updateRequestedOn: 'sellers' }));
                        dispatch(updateCurrentUserData({ name: user.seller.name, avatar: user.seller.avatar, status: user.seller.status }))
                      }}
                    />
                  );
                })
              )}
            </TabPane>
            <TabPane tabId="2">
              {customers.length === 0 ? (
                <p>No any customers</p>
              ) : (
                (debouncedText === ""
                  ? customers
                  : [...getFilteredCustomer()]
                ).map((user, key) => {
                  const isCustomer = currRole === "customer";
                  return (
                    <SidebarUser
                      key={key}
                      userId={isCustomer ? user.seller.id : user.customer.id}
                      userName={
                        isCustomer ? user.seller.name : user.customer.name
                      }
                      id={isCustomer ? user.customer.id : user.seller.id}
                      lastMessage={user.message}
                      isMe={user?.position === "right" ? true : false}
                      showBold={user?.show_bold}
                      time={user.created_at}
                      userAvatar={
                        isCustomer ? user.seller.avatar : user.customer.avatar
                      }
                      onPressed={() => {
                        dispatch(setNewConversationID({ id: isCustomer ? user.seller.id : user.customer.id, convContext: 'customers' }));
                        dispatch(onChatPressed({ chatId: user.id, updateRequestedOn: 'customers' }));
                        dispatch(updateCurrentUserData({ name: user.customer.name, avatar: user.customer.avatar, status: user.customer.status }))
                      }}
                    />
                  );
                })
              )}
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default MessageSideBar;
